/**
 * This method sort Array Objects on basis of key
 * (For example: to sort by displayName key should be key = 'displayName')
 */
export const sortArrayObjects = (key) => {
  return function (a, b) {
    if (!Object.prototype.hasOwnProperty.call(a, key) || !Object.prototype.hasOwnProperty.call(b, key)) {
      // Property doesn't exist on either object
      return 0;
    }

    const itemA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
    const itemB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (itemA > itemB) {
      comparison = 1;
    } else if (itemA < itemB) {
      comparison = -1;
    }

    return comparison;
  };
};
